<template>
  <div class="bg-gray-100">
    <div class="max-w-3xl mx-auto py-10 px-4 sm:px-6 lg:px-8">
      <Headline title="Unsere Partner:"/>
      <div class="mt-2 grid grid-cols-1 sm:grid-cols-3 gap-6 sm:gap-4">
        <div class="col-span-1 flex justify-center opacity-50" v-for="partner in partnerList" v-bind:key="partner.link">
          <a :href="partner.link" target="_blank" rel="noopener">
            <p class="text-center text-sm pb-2 sm:pb-10"> {{partner.text}}</p>
            <img class="mx-auto h-16 md:h-20 lg:h-20" :src="partner.imageSrc" :alt="partner.alt">
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import Headline from "../../common/components/Headline";

const partnerList = [
  {link: 'https://www.aareal-bank.com/', text: 'Unsere Muttergesellschaft: Aareal Bank', imageSrc: '/images/aareal-logo.png', alt: 'Aareal Bank Logo'},
  {link: 'https://www.axa.de/', text: 'Unser Versicherungspartner: AXA Versicherung', imageSrc: '/images/axa-logo-grey.png', alt: 'Axa Logo'},
  {link: 'https://finance.arvato.com/de/', text: 'Ihre Daten sind bei uns sicher: geprüft und validiert durch infoscore', imageSrc: '/images/arvato-infoscore-logo.png', alt: 'Arvato Infoscore Logo'},
]
</script>
